// Core
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';

// Components
import UserPurchasesDetailsContent from './components/UserPurchasesDetailsContent';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

const UserPurchasesDetails = () => {
  const { id } = useParams();

  const isUserPurchase = usePermissionStatusByKey(
    'GET:/admin/user-purchases/:id',
  );

  const { data: userPurchase, isLoading, isError } = useQuery({
    queryKey: ['user-purchase', id],
    enabled: !!id && !!isUserPurchase,
    refetchOnWindowFocus: false,
    refetchOnError: false,
    queryFn: async () => {
      return (await apiService.getUserPurchase({ id })).data;
    },
  });

  return isError ? (
    <div>Not Found</div>
  ) : isLoading ? (
    <div>Loading...</div>
  ) : (
    <UserPurchasesDetailsContent posTransaction={userPurchase} />
  );
};

export default UserPurchasesDetails;
